<!-- @TODO -->
<!-- [class.component-dark-theme]="themeService.isDark()" -->
<mat-card
  class="daxa-card completed-projects-card border-radius border-none d-block"

>
  <mat-card-content>
    <div class="d-flex justify-content-between">
      <div class="title">
        <h5>
          Partido {{ index() + 1 }}
        </h5>
      </div>
      <!-- <div class="number fw-medium lh-1 text-body">
        <span class="material-symbols-outlined" style="position: relative; top: 3px; font-size: 18px;">
          location_on
        </span>
        Cancha {{ i + 1 }}
      </div> -->
      <div class="number fw-medium lh-1" style="margin-top: 4px;">
        <!-- text-body -->
        @if (game().status === 'pending') {
          <span class="text-soft-warning" style="color: #FFA308 !important; padding: 2px 4px;">Pendiente</span>
          <!-- <span class="badge text-bg-warning">Pendiente</span> -->
        } @else if (game().status === 'in_progress') {
          <span class="text-bg-daxa" style="padding: 2px 4px;">En curso</span>
        } @else if (game().status === 'finished') {
          <span class="text-soft-success" style="padding: 2px 5px;">Finalizado</span>
          <!-- <span class="badge text-bg-success">Finalizado</span> -->
        }
      </div>
    </div>

    <!-- <div class="info d-flex align-items-center justify-content-between mt-5">
      <div class="info d-flex align-items-center">
        <div class="image">
          <img src="images/avatar.png" class="rounded-circle" alt="admin-image" style="width: 40px; height: 40px; min-width: 40px; min-height: 40px;" />
        </div>
        <span class="d-block fw-medium" [ngClass]="{'text-body': (game().winner === 2)}" style="margin-left: 10px;">
          {{ game().player1FullName }}
        </span>
        @if (game().winner === 1) {
          <span class="material-symbols-outlined" style="margin-left: 10px; color: green;">
            check
          </span>
        }
      </div>
      <div class="score d-flex" style="column-gap: 12px;">
        @for (score of game().scores; track score.id) {
          <div style="flex-grow: 1;">{{ score.score1 }}</div>
        }
      </div>
    </div> -->

    <!-- <div class="info d-flex align-items-center justify-content-between mt-10">
      <div class="info d-flex align-items-center">
        <div class="image">
          <img src="images/avatar.png" class="rounded-circle" alt="admin-image" style="width: 40px; height: 40px; min-width: 40px; min-height: 40px;" />
        </div>
        <span
          class="d-block fw-medium"
          [ngClass]="{'text-body': (game().winner === 1)}"
          style="margin-left: 10px;"
        >
          {{ game().player2FullName }}
        </span>
        @if (game().winner === 2) {
          <span class="material-symbols-outlined" style="margin-left: 10px; color: green;">
            check
          </span>
        }
      </div>
      <div class="score d-flex" style="column-gap: 12px;">
        @for (score of game().scores; track score.id) {
          <div style="flex-grow: 1;">{{ score.score2 }}</div>
        }
      </div>
    </div> -->

    <table style="width: 100%;">
      <tbody>
      <tr>
        <td>
          <div class="info d-flex align-items-center">
            <div class="image">
              <img
                [ngSrc]="bucketUrl + '/images/avatars/' + game().avatarImg1"
                width="40"
                height="40"
                alt="admin-image"
                class="rounded-circle"
                style="max-width: none;"
              />
            </div>
            <span
              class="d-block fw-medium"
              [ngClass]="{'text-body': (game().winner === 2)}"
              style="margin-left: 10px;"
            >
              {{ game().drawing1?.team?.label }}
              <!-- @TODO -->
              <!-- @if (game().player1?.eventRank) {
                ({{ game().player1?.eventRank }})
              } -->
            </span>
          </div>
        </td>
        <td style="width: 35px;">
          @if (game().winner === 1) {
            <span class="material-symbols-outlined" style="margin-top: 4px; color: green;">
              check
            </span>
          }
        </td>
        @for (score of game().scores; track score.id) {
          <td style="width: 25px; white-space: nowrap;">
            @if (score.score1 !== undefined) {
              {{ score.score1 }}<sup style="font-size: 11px;">{{ score.extrascore1 }}</sup>
            } @else {
              <span class="text-body">-</span><sup style="font-size: 11px;">{{ score.extrascore1 }}</sup>
            }
          </td>
        }
      </tr>
      <tr>
        <td>
          <div class="info d-flex align-items-center">
            <div class="image">
              <img
                [ngSrc]="bucketUrl + '/images/avatars/' + game().avatarImg2"
                width="40"
                height="40"
                alt="admin-image"
                class="rounded-circle"
                style="max-width: none;"
              />
            </div>
            <span
              class="d-block fw-medium"
              [ngClass]="{'text-body': (game().winner === 1)}"
              style="margin-left: 10px;"
            >
              {{ game().drawing2?.team?.label }}
              <!-- @TODO -->
              <!-- @if (game().player2?.eventRank) {
                ({{ game().player2?.eventRank }})
              } -->
            </span>
          </div>
        </td>
        <td>
          @if (game().winner === 2) {
            <span class="material-symbols-outlined" style="margin-top: 4px; color: green;">
              check
            </span>
          }
        </td>
        @for (score of game().scores; track score.id) {
          <td style="white-space: nowrap;">
            @if (score.score2 !== undefined) {
              {{ score.score2 }}<sup style="font-size: 11px;">{{ score.extrascore2 }}</sup>
            } @else {
              <span class="text-body">-</span><sup style="font-size: 11px;">{{ score.extrascore2 }}</sup>
            }
          </td>
        }
      </tr>
      </tbody>
    </table>

    <!-- <div class="info d-md-flex aling-items-center justify-content-between"> -->
    <div class="info2 mt-15">
      <div class="d-flex align-items-center">
        <div
          matTooltip="Ubicación"
          matTooltipPosition="above"
          class="icon rounded-circle position-relative text-daxa text-center"
        >
          <i class="material-symbols-outlined">place</i>
        </div>
        <div>
          <!-- <span class="d-block fw-medium">Ubicación</span> -->
          @if (!game().court?.name) {
            <span class="d-block text-bg-warning" style="padding: 1px 4px;">
              @if (game().status === 'pending') {
                Por definir
              } @else {
                No disponible
              }
            </span>
          } @else {
            <span class="d-block text-body" style="padding-top: 1px; padding-bottom: 1px;">
              {{ game().court?.name }}
            </span>
          }
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div
          matTooltip="Fecha/hora"
          matTooltipPosition="above"
          class="icon rounded-circle position-relative text-info text-center"
        >
          <i class="material-symbols-outlined">calendar_clock</i>
        </div>
        <div>
          <!-- <span class="d-block fw-medium">Fecha/hora</span> -->
          <!-- @TODO: usar enum -->
          @if (game().status === 'pending') {
            @if (!game().date) {
              <span class="d-block text-bg-warning" style="padding: 1px 4px;">
                Por definir
              </span>
            } @else {
              <span class="d-block text-body" style="padding-top: 1px; padding-bottom: 1px;">
                {{ game().date | date: 'dd/MM/yyy' }}
                <br />
                {{ game().date | date: 'h:mm a' }}
              </span>
            }
          } @else {
            @if (!game().startDate) {
              <span class="d-block text-bg-warning" style="padding: 1px 4px;">
                No disponible
              </span>
            } @else {
              <span class="d-block text-body" style="padding-top: 1px; padding-bottom: 1px;">
                {{ game().startDate | date: 'dd/MM/yyy' }}
                <br />
                {{ game().startDate | date: 'h:mm a' }}
              </span>
            }
          }
        </div>
      </div>
      @if (['in_progress', 'finished'].includes(game().status)) {
        <div class="d-flex align-items-center">
          <div
            matTooltip="Duración"
            matTooltipPosition="above"
            class="icon rounded-circle position-relative text-primary text-center"
          >
            <i class="material-symbols-outlined">update</i>
          </div>
          <div>
            <!-- <span class="d-block fw-medium">Duración</span> -->
            @if (game().status === 'in_progress') {
              <span class="d-block text-body" style="padding-top: 1px; padding-bottom: 1px;">
                {{ duration$ | async }}
              </span>
            } @else if (game().status === 'finished') {
              @if (!game().startDate || !game().endDate) {
                <span class="d-block text-bg-warning" style="padding: 1px 4px;">
                  No disponible
                </span>
              } @else {
                <span class="d-block text-body" style="padding-top: 1px; padding-bottom: 1px;">
                  {{ game().duration }}
                </span>
              }
            }
          </div>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
